export default [
  {
    name: 'Conversaciones',
    icon: 'mdi-forum',
    path: '/admin/conversations',
    component: () =>
      import(/* webpackChunkName: "admin-conversations" */ './views/AdminConversations'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
    children: [
      {
        name: 'threadAdminDetail',
        path: '/admin/conversations/thread/:thread',

        component: () =>
          import(/* webpackChunkName: "admin-conversations" */ './views/AdminConversations'),
        meta: {
          admin: true,
          drawer: false,
          tooltip: null,
        },
      },
    ],
  },
];
